<template>
  <div>
    <div class="alerts-wrapper" v-if="letShowUpdatePlanMessage">
      <div class="alerts-wrapper__icon">
        <v-img width="24px" height="24px" src="@/assets/icons/svg/alert.svg" />
      </div>
      <div class="alerts-wrapper__text">
        You can add only {{getLimit('warehouses')}} {{getLimit('warehouses') | currentWarehousesMultipleOrSingleName}} on your current plan.
        <b>
          <span class="update-plan-link text-yellow-9" @click="showUpgradeSubscriptionPlanPopup">Upgrade Plan</span>
        </b>
      </div>
    </div>
    <div class="table-wrapper mt-6">
      <v-row class="table-controls mb-1 items-center">
        <v-col cols="12">
          <div v-if='$getRight("warehouseCreate") && $getRight("warehouseView")'>
            <v-btn
              v-if='getUsed("warehouses")<getLimit("warehouses")'
              color='transparent'
              depressed
              @click='handleClickAddWarehouse'
              class='px-2'
            >
              <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
              <span class="text-subtitle-2 font-weight-bold">Add Warehouse</span>
            </v-btn>
            <v-btn
              v-else
              color='transparent'
              depressed
              @click='showUpgradeSubscriptionPlanPopup'
              class='px-2'
            >
              <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
              <span class="text-subtitle-2 font-weight-bold">Add Warehouse</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-divider />
      <v-row class="justify-space-between">
        <v-col cols='12' class="px-3">
          <v-data-table
            :headers="headers"
            :items="filtredList"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            item-key="created"
            hide-default-footer
            class="cursor-point"
          >
            <template :slot='"no-results"'>
              <p class="text-h6 my-16">No Data found</p>
            </template>
            <template :slot='"no-data"'>
              <p class="text-h6 my-16">No Data found</p>
            </template>
            <template v-slot:[`item.activeSwitch`]="{ item }">
              <v-switch
                v-model='item.active'
                color='success'
                @change='handleSwitchActivityItem(item)'
              />
            </template>
            <template v-slot:[`item.status`]='{item}'>
              <span v-if='item.active' class='active-warehouse-status-label'>active</span>
              <span v-else>not active</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-row class="flex-nowrap">
                <v-col cols="4" class="px-1" v-if='getIsOwner'>
                  <v-tooltip top transition="fade-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <router-link
                        v-bind="attrs"
                        v-on="on"
                        :to="{name: 'EditWarehouse', params: {id: item.id}}"
                      >
                        <img
                          class="mr-1 cursor-pointer"
                          style="height: 16px; width: 16px"
                          src="@/assets/icons/svg/draw.svg"
                          title="Edit"
                        />
                      </router-link>
                    </template>
                    <span>edit warehouse</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="4" class="px-1" v-if='getIsOwner'>
                  <v-tooltip top transition="fade-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <img
                        style="height: 16px; width: 16px"
                        src="@/assets/icons/svg/delete1.svg"
                        class="cursor-pointer"
                        @click='itemToDelete=item'
                        v-bind="attrs"
                        v-on="on"
                        title="Delete"
                      />
                    </template>
                    <span>delete warehouse</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="pagination-wrapper">
        <v-col cols="5">
          <span class="text-nowrap mr-2">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                outlined
                v-bind="attrs"
                v-on="on"
                style="padding: 0; font-weight: 600"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in itemsPerPageOptions"
                :key="index"
                link
                @click="itemsPerPage = item"
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="7" class="d-flex justify-end">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
            color="#7972C0"
          />
        </v-col>
      </v-row>
    </div>
    <make-inactive-popup
      v-if='itemToMakeInactive'
      :item='itemToMakeInactive'
      :showPopup='!!itemToMakeInactive'
      @close='cancelItemToMakeInactive'
      @makeInactive='makeInactiveItem'
    />
    <add-warehouse
      v-if='getWarehousesAddingPopupState'
      :showPopup='getWarehousesAddingPopupState'
      @cancel='$store.commit("warehouses/addWarehousePopup", false)'
    />
    <delete-warehouse
      v-if='itemToDelete'
      :item='itemToDelete'
      :showPopup='!!itemToDelete'
      @cancel='itemToDelete=null'
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import makeInactivePopup from '@/components/warehouses/popups/makeInactive'
import addWarehouse from '@/components/warehouses/popups/addWarehouse'
import deleteWarehouse from '@/components/warehouses/popups/deleteWarehouse'
import { POSSIBLE_TO_ADD_WAREHOUSES_BEFORE_UPDATE } from '@/constant'
import { getLimitMixin } from '@/mixins/getLimit'
export default {
  name: 'WarehousesList',
  props: {
    searchQuery: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      navTableItems: [
        {
          index: 1,
          text: 'Warehouses',
          disabled: false
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 20, 25, 50],
      headers: [
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'activeSwitch'
        },
        {
          text: 'Status',
          value: 'status',
          sortable: true,
          align: 'start',
          width: 150
        },
        {
          text: 'Name',
          value: 'name',
          sortable: true,
          align: 'start'
        },
        {
          text: 'Number of Folders',
          value: 'info.countCategories',
          sortable: true,
          align: 'start'
        },
        {
          text: 'Number of Users',
          value: 'info.countUsers',
          sortable: true,
          align: 'start'
        },
        { text: '', value: 'actions', sortable: false, align: 'start' }
      ],
      itemToMakeInactive: null,
      itemToDelete: null,
      currentUserPlan: '',
      UpgradePlanPopupIsOpen: false,
      letShowAddWarehouseDialog: false
    }
  },
  mixins: [getLimitMixin],
  filters: {
    currentWarehousesMultipleOrSingleName(v) {
      const count = ('' + v).substr(-1, 1)
      if (+count === 1) return 'warehouse'
      return 'warehouses'
    }
  },
  computed: {
    ...mapGetters('user', ['getIsOwner']),
    ...mapGetters('warehouses', ['getWarehousesList', 'getActiveWarehouse', 'getWarehousesAddingPopupState']),
    letShowUpdatePlanMessage() {
      const plan = this.currentUserPlan
      if (plan === 'Free' || plan === 'No Plan' || plan === 'Business') return true
      return false
    },
    filtredList() {
      if (this.searchQuery.length) {
        return this.getWarehousesList.filter(item => {
          return item.name.toLowerCase().search(new RegExp(this.searchQuery.toLowerCase()), 'g') >= 0
        })
      }
      return this.getWarehousesList
    }
  },
  methods: {
    ...mapActions(['showUpgradeSubscriptionPlanPopup']),
    handleSwitchActivityItem(item) {
      if (!item.active) {
        this.itemToMakeInactive = item
      } else {
        item.active = true
        this.setWarehouseActive(item.id)
      }
      this.$store.commit('warehouses/handleActiveWarehouse', item.id)
    },
    cancelItemToMakeInactive() {
      this.$store.commit('warehouses/setWarehouseActive', this.itemToMakeInactive.id)
      this.itemToMakeInactive = null
    },
    makeInactiveItem() {
      this.$store.commit('warehouses/setWarehouseInactive', this.itemToMakeInactive.id)
      this.setWarehouseActive(this.itemToMakeInactive.id)
      this.itemToMakeInactive = null
    },
    handleClickAddWarehouse() {
      if (this.letShowUpdatePlanMessage && this.getWarehousesList.length === POSSIBLE_TO_ADD_WAREHOUSES_BEFORE_UPDATE) {
        this.$store.dispatch('showUpgradeSubscriptionPlanPopup', '')
      } else {
        this.$store.commit('warehouses/addWarehousePopup', true)
      }
    },
    ...mapActions([
      'showUpgradeSubscriptionPlanPopup'
    ]),
    ...mapActions('warehouses', ['setWarehouseActive'])
  },
  created() {
    this.currentUserPlan = JSON.parse(localStorage.getItem('curUserData')).plan.name
  },
  components: {
    makeInactivePopup,
    addWarehouse,
    deleteWarehouse
  }
}
</script>

<style lang="scss">
  .active-warehouse-status-label {
    font-weight: 500;
    color: #7671bd;
  }
  .v-application .update-plan-link {
    display: inline-block;
    color: #fec111;
    text-decoration: underline;
    font-style: italic;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
      text-decoration: none;
    }
  }
</style>
